/*=========================================================================================
  File Name: moduleClient.js
  Description: Client Module
==========================================================================================*/


import state from './moduleClientState.js'
import mutations from './moduleClientMutations.js'
import actions from './moduleClientActions.js'
import getters from './moduleClientGetters.js'

export default {
  clientEnableList: [
    {value:'0', label:'Разрешен', color:'success', tag:'enabled'},
    {value:'1', label:'Запрещен', color:'warning', tag:'disabled'},
  ],
  clientRegList: [
    {value:'0', label:'Активирован', color:'success', tag:'activated'},
    {value:'1', label:'Не активирован', color:'danger', tag:'disactivated'},
  ],

  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
